export default __webpack_public_path__ + "static/media/bernay11.b949e16b.jpg";